//charts
import { followerGrowthConfig } from '@/lib/analytics/charts/instagram/followerGrowthHistory';
//kpis
import { avgEngagementRatePostConfig } from '@/lib/analytics/kpis/instagram/avgEngagementRatePost';
import { avgEngagementReachPostConfig } from '@/lib/analytics/kpis/instagram/avgEngagementReachPost';
import { followersEvolutionConfig } from '@/lib/analytics/kpis/instagram/followersEvolution';
import { followersEvolutionPercentageConfig } from '@/lib/analytics/kpis/instagram/followersEvolutionPercentage';
import { storiesConfig } from '@/lib/analytics/kpis/instagram/stories/stories';
import { storiesReachConfig } from '@/lib/analytics/kpis/instagram/stories/storiesReach';
import { storiesViewsConfig } from '@/lib/analytics/kpis/instagram/stories/storiesView';
import { totalEngagementConfig } from '@/lib/analytics/kpis/instagram/totalEngagement';
import { totalFollowersConfig } from '@/lib/analytics/kpis/instagram/totalFollowers';
import { totalPostsConfig } from '@/lib/analytics/kpis/instagram/totalPosts';
import { totalPostsReachConfig } from '@/lib/analytics/kpis/instagram/totalPostsReach';
import { totalPostsViewsConfig } from '@/lib/analytics/kpis/instagram/totalPostsViews';
//widget
import { mostRecentPostsConfig } from '@/lib/analytics/widget/instagram/mostRecentPostsConfig';
import { mostRecentStoriesConfig } from '@/lib/analytics/widget/instagram/mostRecentStoriesConfig';
// lib
import { ORIENTATION_HORIZONTAL } from '@/lib/gridElements/orientation';
import { SIZE_33, SIZE_FULL } from '@/lib/gridElements/size';

export const OverviewInstagram = [
    // Line 1
    totalFollowersConfig,
    followersEvolutionConfig,
    followersEvolutionPercentageConfig,
    // Line 2
    { ...followerGrowthConfig, size: SIZE_FULL },
    // Line 3
    { ...totalPostsConfig, size: SIZE_33 },
    { ...totalPostsViewsConfig, orientation: ORIENTATION_HORIZONTAL, size: SIZE_33 },
    { ...totalPostsReachConfig, orientation: ORIENTATION_HORIZONTAL, size: SIZE_33 },
    // Line 4
    { ...totalEngagementConfig, orientation: ORIENTATION_HORIZONTAL, size: SIZE_33 },
    { ...avgEngagementRatePostConfig, size: SIZE_33 },
    { ...avgEngagementReachPostConfig, size: SIZE_33 },
    // Line 5
    { ...storiesConfig, size: SIZE_33 },
    { ...storiesViewsConfig, size: SIZE_33 },
    { ...storiesReachConfig, size: SIZE_33 },
    // Line 6
    mostRecentPostsConfig,
    // Line 7
    mostRecentStoriesConfig
];

export const requestInstagramParams = [
    // Instagram Account metrics
    [
        'followers',
        'followers_evolution',
        'followers_evolution_percentage',
        'views',
        'followers_history',
        'stories_views',
        'stories_reach',
        'stories'
    ],
    // Instagram Account metrics | Instagram Media | Instagram Ads
    ['average_engagement_rate_per_post', 'post_engagements'],
    // Instagram Media | Instagram Ads
    [
        'average_engagement_on_reach_per_post',
        'likes',
        'comments',
        'likes_history',
        'comments_history'
    ],
    // Instagram Media
    ['posts', 'posts_reach']
];

export const requestInstagramOtherParameters = {
    media_life_span: {
        type: 'likes',
        id_media: null
    }
};
